// extracted by mini-css-extract-plugin
export default {"type":"FeedTypeFilter_type__H7LaJ","name":"FeedTypeFilter_name__ihpTF","total":"FeedTypeFilter_total__WGfzU"};